export enum ResponsiveCalendarMode {
  Month = 'month',
  WeekHorizontal = 'weekHorizontal',
  WeekVertical = 'weekVertical',
}
